export default __webpack_public_path__ + "static/media/checkout-power-station.15a82a43.jpg";